import PropTypes from 'prop-types';
import ItemCard from '../ItemCard';

export default class CategoryItem extends React.Component {
  static propTypes = {
    itemsByEvent: PropTypes.array,
    categoryName: PropTypes.string,
    modalUpdateHandler: PropTypes.func,
    isSuccessAddedHandler: PropTypes.func,
    userId: PropTypes.number,
    isSearchedItem: PropTypes.bool
  };
  static defaultProps = {
    itemsByEvent: [],
    categoryName: '',
    modalUpdateHandler: () => null,
    userId: null,
    isSearchedItem: false
  };
  constructor(props) {
    super(props);
  }

  _filterItemsByCategory = (allItems) => allItems.filter((el) =>  el.categoryName === this.props.categoryName);

  _renderItems = (filteredItems) => filteredItems.map((item, index) => <ItemCard key={ index } itemData = { item } modalUpdateHandler={this.props.modalUpdateHandler} isSuccessAddedHandler={this.props.isSuccessAddedHandler} userId={this.props.userId} isGrid/> );

  render() {
    const { itemsByEvent, categoryName } = this.props;
    const allItems = itemsByEvent ? itemsByEvent : [];
    const filteredItems = this.props.isSearchedItem ? allItems : this._filterItemsByCategory(allItems);
    const currentCategoryItems = this._renderItems(filteredItems);

    return (
      <div className="row category-container">
        <div className="xs-12 catalog-category-text">
          <span className="select-from">select from</span>
          <h1 className="category-name">
            { categoryName }
          </h1>
        </div>

        <div className="grey-divider"/>
        { currentCategoryItems }
      </div>
    );
  }
}
